module.exports = __webpack_public_path__ + "img/cross-icon.5d8fa210.svg";